import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=8b369ca2&scoped=true"
import script from "./Agregar.vue?vue&type=script&lang=js"
export * from "./Agregar.vue?vue&type=script&lang=js"
import style0 from "./Agregar.vue?vue&type=style&index=0&id=8b369ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b369ca2",
  null
  
)

export default component.exports